import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MessageService } from "primeng/api";
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CoreService {
  accessToken: any;
  options;
  fileToUpload !: File

  constructor(private client: HttpClient, private messageService: MessageService, private sanitizer: DomSanitizer) {
    this.options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.accessToken,
      })
    };
  }

  getCurrentUser() {
    return this.client.get(`${environment.apiUrl}/user/getcurrentuser`)
  }

  getOperators(tenantId: number) {
    return this.client.get(`${environment.apiUrl}/User/GetUsersInRole/Operator`, { params: { tenantId } })
  }
  getRoles() {
    return this.client.post(`${environment.apiUrl}/Role/Get`, {})
  }
  assignRoleToUser(value: any, userName: any) {
    return this.client.post(`${environment.apiUrl}/Role/AssignRoleToUser?username=${userName}`, value)
  }

  getIpCliente(): Observable<any> {
    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
      }),
    };
    return this.client
      .get('https://api.ipify.org', options).pipe(map(res => {
        console.log(res);;
        return res
      }));
  }

  getLang(position: any): Observable<any> {

    return this.client.get(`https://maps.googleapis.com/maps/api/geocode/json?
    latlng=${position.coords.latitude},${position.coords.longitude}&key={GOOGLE_MAP_KEY}`);

  }

  getSitemap(): Observable<any> {
    let options = {
      headers: new HttpHeaders({
        "x-none": "true",
        "Content-Type": "text/xml",
        responseType: 'blob'
      }),
    };
    return this.client.get(`${environment.apiUrl.replace('/api', '')}/sitemap.xml`, options);
  }
}
